import { SURVEYS } from "./surveys/index.ts";

const list = document.getElementById("list");
if (list) {
  list.replaceChildren(...SURVEYS.filter(s => s.status !== "draft").map(s => {
    const a = document.createElement("a");
    a.href = `/s/${s.slug}`;
    a.className = "card-link";

    const sec = document.createElement("section");
    sec.className = "block";

    const h = document.createElement("h2");
    h.textContent = s.title;

    const p = document.createElement("p");
    p.className = "blurb";
    p.textContent = s.blurb;

    const cta = document.createElement("p");
    cta.className = "cta";
    cta.textContent = s.status === "open" ? "Open →" : "Closed — view →";

    sec.append(h, p, cta);
    a.append(sec);
    return a;
  }));
}
